<!-- Customer Names Popup -->
<div class="customer-names-container">
  <!-- Header -->
  <div class="popup-header">
    <div class="header-content">
      <h3 class="popup-title">Included Customers</h3>
      <p class="popup-subtitle">
        <span class="badge bg-primary">{{ allCustomerNames().length }}</span>
        @if (allCustomerNames().length === 1) {
          customer in this schedule
        } @else {
          customers in this schedule
        }
      </p>
    </div>
    <button
      class="btn-close"
      type="button"
      [attr.aria-label]="'Close'"
      (click)="onClose()"
    >
      <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
    </button>
  </div>

  <!-- Search Input -->
  @if (allCustomerNames().length > 5) {
    <div class="search-container">
      <div class="input-group">
        <span class="input-group-text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16"
          >
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
            />
          </svg>
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Search customers..."
          [value]="searchQuery()"
          (input)="searchQuery.set($any($event.target).value)"
        />
        @if (searchQuery()) {
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="clearSearch()"
            title="Clear search"
          >
            ✕
          </button>
        }
      </div>
      @if (filteredCustomerNames().length !== allCustomerNames().length) {
        <div class="search-results-text text-muted small mt-2">
          Showing {{ filteredCustomerNames().length }} of {{ allCustomerNames().length }} customers
        </div>
      }
    </div>
  }

  <!-- Customer List -->
  <div class="customer-list-container">
    @if (filteredCustomerNames().length > 0) {
      <ul class="customer-list list-unstyled mb-0">
        @for (customer of filteredCustomerNames(); track customer) {
          <li class="customer-list-item">
            <div class="customer-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-building"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                />
                <path
                  d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z"
                />
              </svg>
            </div>
            <span class="customer-name">{{ customer }}</span>
          </li>
        }
      </ul>
    } @else {
      <div class="empty-state text-center py-4">
        <p class="text-muted mb-0">No customers match your search</p>
      </div>
    }
  </div>
</div>
